/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateExamCommand
 */
export interface UpdateExamCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateExamCommand
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateExamCommand
     */
    repairmanId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateExamCommand
     */
    examTypeId: string;
    /**
     * 
     * @type {Date}
     * @memberof UpdateExamCommand
     */
    expirationDate?: Date | null;
}

export function UpdateExamCommandFromJSON(json: any): UpdateExamCommand {
    return UpdateExamCommandFromJSONTyped(json, false);
}

export function UpdateExamCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateExamCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'repairmanId': json['repairmanId'],
        'examTypeId': json['examTypeId'],
        'expirationDate': !exists(json, 'expirationDate') ? undefined : (json['expirationDate'] === null ? null : new Date(json['expirationDate'])),
    };
}

export function UpdateExamCommandToJSON(value?: UpdateExamCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'repairmanId': value.repairmanId,
        'examTypeId': value.examTypeId,
        'expirationDate': value.expirationDate === undefined ? undefined : (value.expirationDate === null ? null : value.expirationDate.toISOString()),
    };
}


